import React from 'react'

interface ElaraErrorBoundaryState {
    hasError: boolean
}

/**
 * Class-based error boundary that catches render errors in ELARA components
 * without crashing the parent consultation page.
 */
export class ElaraErrorBoundary extends React.Component<
    { children: React.ReactNode },
    ElaraErrorBoundaryState
> {
    constructor(props: { children: React.ReactNode }) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(): ElaraErrorBoundaryState {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo): void {
        console.error('[ELARA] Component crashed — isolating from consultation UI:', error, info.componentStack)
    }

    render() {
        if (this.state.hasError) {
            // Render nothing — ELARA is optional, consultation must keep working
            return null
        }
        return this.props.children
    }
}
